const not = <T>(a: T[], b: T[]): T[] => a.filter((valueA) => !b.some((valueB) => valueB === valueA));

export default not;
